import { Component, Input } from '@angular/core';
import { MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'lc-company-menu-item',
  templateUrl: './company-menu-item.component.html',
  styleUrls: ['./company-menu-item.component.scss'],
  imports: [
    MatListItem,
    MatIcon,
    MatTooltip,
  ],
})
export class CompanyMenuItemComponent {
  @Input() companyName: string;
  @Input() isExpanded: boolean = true;
}
